const linkState = {
  title: 'Stay tuned',
  description: 'Sign up to get the latest news, updates and special offers',
  background: {
    type: 'image',
    imageURL: '',
    color: '',
  },
  actionData: {
    actionTemplate: 'default',
    actionType: 'link',
    buttonText: '',
    buttonLink: '',
    actionRedirect: 'newTab',
  },
};

export default linkState;
